module.exports = __webpack_public_path__ + "media/components/participants_visible_icon/static/ShapeInvisible-92bbfc4c069d853abdebf55e1d03af9b.png";